import React from 'react';
import { get } from 'lodash';

//local
import { CSrOrderListNotesWorkLineItemService } from 'services/cSROrderListNotesWorkLineItem';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

// React view component to render
import { cSrOrderListNotesLineItem as CSrOrderListNotesLineItemView } from 'ui/views/widgets/cSROrderListNotesLineItem';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CsrOrderListNotesLineItem } from 'ui/containers/CSROrderListNotesLineItem';
 *
 * // render
 * <CsrOrderListNotesLineItem propName='propValue'/>
 */
export class CsrOrderListNotesLineItem extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        this.cSrOrderListNotesWorkLineItemService = new CSrOrderListNotesWorkLineItemService();

        this.fetchComponentData();

    }

    async fetchComponentData() {
        log.debug( 'CsrOrderListNotesLineItem.fetchComponentData()' );

        // cancel ongoing request
        this.cSrOrderListNotesWorkLineItemService.cancel();

        try {
            const { status, data }  = await this.cSrOrderListNotesWorkLineItemService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CSrOrderListNotesLineItemView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                onCancelClick={ this.props.onCancelClick }
                onAddClick={ this.props.onAddClick }
            />
        );
    }
}

// set display name
CsrOrderListNotesLineItem.displayName = 'CsrOrderListNotesLineItem';

// set default props
CsrOrderListNotesLineItem.defaultProps = {};

// prop types
CsrOrderListNotesLineItem.propTypes = {};
